import React, { useEffect, useState } from "react";
import { UrduInput } from "../../../../Components/Shared/UrduInput";
import { UiModal } from "../../../../Components/Shared/UiModal";

const EMPTY_FORM = {
  name: "",
  categoryName_ur: "",
  status: true,
};

function AddBlogCategoryModal({
  modalOpen,
  toggleModal,
  category,
  handleSaveCategory,
}) {
  const [categoryData, setCategoryData] = useState(EMPTY_FORM);
  const [nameError, setNameError] = useState("");

  useEffect(() => {
    if (!modalOpen) {
      setCategoryData(EMPTY_FORM);
      setNameError("");
      return;
    }

    if (category) {
      setCategoryData({
        name: category.name || "",
        categoryName_ur: category.categoryName_ur || "",
        status: category.status !== undefined ? category.status : true,
      });
    } else {
      setCategoryData(EMPTY_FORM);
    }
    setNameError("");
  }, [modalOpen, category]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCategoryData((prevData) => ({
      ...prevData,
      [name]: value === "true" ? true : value === "false" ? false : value,
    }));
    if (name === "name" && nameError) {
      setNameError("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setNameError("");

    if (!categoryData.name.trim()) {
      setNameError("Category name is required.");
      return;
    }

    handleSaveCategory(
      {
        name: categoryData.name.trim(),
        categoryName_ur: categoryData.categoryName_ur,
        status: categoryData.status,
      },
      category ? category.id : null,
    );
  };

  const handleCloseModal = () => {
    setCategoryData(EMPTY_FORM);
    setNameError("");
    toggleModal();
  };

  const isEditMode = Boolean(category);

  return (
    <UiModal
      isOpen={modalOpen}
      onClose={handleCloseModal}
      eyebrow="Blogs"
      title={isEditMode ? "Edit Category" : "Add Category"}
      as="form"
      onSubmit={handleSubmit}
      footer={
        <>
          <button
            type="button"
            onClick={handleCloseModal}
            className="ui-btn-cancel min-w-[108px]"
          >
            Cancel
          </button>
          <button type="submit" className="ui-btn-save min-w-[108px]">
            {isEditMode ? "Update" : "Save"}
          </button>
        </>
      }
    >
      <section className="ui-modal-section">
        <h4 className="ui-modal-section-title">Category details</h4>
        <div className="space-y-4">
          <div>
            <label className="ui-form-label">
              Category Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="name"
              value={categoryData.name}
              onChange={handleInputChange}
              placeholder="Blog Category Name"
              className={`ui-input-field ${
                nameError ? "border-brand-error" : ""
              }`}
            />
            {nameError ? <p className="ui-form-error">{nameError}</p> : null}
            <UrduInput
              label="زمرہ کا نام"
              name="categoryName_ur"
              value={categoryData.categoryName_ur}
              onChange={handleInputChange}
            />
          </div>

          <div>
            <label className="ui-form-label">Status</label>
            <select
              name="status"
              value={String(categoryData.status)}
              onChange={handleInputChange}
              className="ui-select-field"
            >
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
        </div>
      </section>
    </UiModal>
  );
}

export default AddBlogCategoryModal;
